import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { CoreModule } from '../../../../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatInputModule, MatFormFieldModule, MatCheckboxModule } from '@angular/material';
import { LoginFormComponent } from './login-form/login-form.component';
import { Routes, RouterModule } from '@angular/router';
import { InfoModalComponent } from '../../../../../test/pages/info-modal/info-modal.component';
import { CustomModalComponent } from '../../../../../test/pages/custom-modal/custom-modal.component';
import { CustomMessageService } from '../../../../../shared/service-proxies/custom-message.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


const routes: Routes = [
	{
		path: '',
		component: LoginComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginFormComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'forgot-password',
				component: ForgotPasswordComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'reset-password',
				component: ResetPasswordComponent,
				data: {returnUrl: window.location.pathname}
			}
		]
	}
];


@NgModule({
  declarations: [
    LoginComponent,
	LoginFormComponent,
	ForgotPasswordComponent,
	ResetPasswordComponent,
	
  ],
  imports: [
    CommonModule,
	CoreModule,
	
	
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
	MatFormFieldModule,
	MatCheckboxModule,
		

  ],
  exports: [LoginComponent],
 
  
})

export class LoginModule {
  static forRoot(): ModuleWithProviders {
		return {
			ngModule: LoginModule,
			providers: [
			
			]
		};
	}
}

